import styled from 'styled-components';

export const SectionTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  position: relative;
  z-index: 1;

  & > .title {
    color: inherit;

    i {
      margin-left: 5px;
      font-size: calc(1em / 1.5);
    }
  }

  .MuiLink-root {
    line-height: 1em;
  }
`;

export default SectionTitleWrapper;
